import { render, staticRenderFns } from "./pre-approved.vue?vue&type=template&id=05a6d0a5&scoped=true"
import script from "./pre-approved.vue?vue&type=script&lang=js"
export * from "./pre-approved.vue?vue&type=script&lang=js"
import style0 from "./pre-approved.vue?vue&type=style&index=0&id=05a6d0a5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6d0a5",
  null
  
)

export default component.exports